import React, { useEffect } from "react";
import { PopupDialog } from "../../components/popupDialog";
import { Button, Carousel } from "react-bootstrap";
import "../../assets/css/popupShop.css";
import { CurrencyLabel } from "../../components/currencyLabel";
import { WooCommerceController } from "../../controllers/wooCommerceController";

export const PopupShopProduct = ({
  open = false,
  handleClose,
  currency,
  selectedProduct = {},
  onAddToCart,
}) => {
  const handleAddToCart = () => {
    if (onAddToCart) {
      onAddToCart(selectedProduct);
    }
    handleClose();
  };

  useEffect(() => {
    if (currency && selectedProduct && Object.keys(selectedProduct).length > 1)
        getVariantDetails(selectedProduct.variations)
  }, [currency, selectedProduct]);

  const getVariantDetails = async () => {
    try {
      const productDetails =
        await WooCommerceController.getProductDetailsByVariationIds(
          selectedProduct.variations
        );
      console.debug("Product Details:", productDetails);
    } catch (error) {
      console.debug("Error fetching product details:", error);
    }
  };

  return (
    <PopupDialog
      name="productModal"
      open={open}
      onClose={handleClose}
      content={
        <div className="product-dialog-container">
          {/* Image Carousel */}
          <div className="product-image-carousel">
            <Carousel interval={3000} fade>
              {selectedProduct.images?.map((image, index) => (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100 product-carousel-image animate-fade-in"
                    src={image.src}
                    alt={image.alt || selectedProduct.name}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          {/* Product Details */}
          <div className="product-details">
            <h3 className="product-name animate-slide-in">
              {selectedProduct.name}
            </h3>
            <p className="product-description animate-slide-in">
              {selectedProduct.description}
            </p>
            <div className="product-price animate-slide-in">
              <strong>Price: </strong>
              <CurrencyLabel currency={currency} />
              {selectedProduct.price}
              <br />
              <strong>Dimensions: </strong> Height:{" "}
              {selectedProduct.dimensions?.height} Length:{" "}
              {selectedProduct.dimensions?.length} Width:{" "}
              {selectedProduct.dimensions?.width}
              <br />
              <strong>Weight: </strong>
              {selectedProduct.weight}
              <br />
              <strong>Options: </strong>
            </div>
          </div>

          {/* Add to Cart Button */}
          <div className="product-actions">
            <Button
              variant="success"
              onClick={handleAddToCart}
              className="add-to-cart-button animate-bounce"
            >
              Add to Cart
            </Button>
          </div>
        </div>
      }
    />
  );
};
